// LanguagePreferences.js
import React from "react";

const LanguagePreferences = ({ languagePreference }) => (
  <section className="p-6">
    <h2 className="text-2xl font-semibold text-gray-800">
      Language Preferences
    </h2>
    <p>
      <strong>App Language:</strong>{" "}
      {languagePreference?.appLanguage || "Not Set"}
    </p>
    <p>
      <strong>Notification Language:</strong>{" "}
      {languagePreference?.notificationLanguage || "Not Set"}
    </p>
  </section>
);

export default LanguagePreferences;
